import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { apiService } from 'app/services/api.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyContent: any;

  constructor(private api: apiService, private metaService: Meta) { }

  ngOnInit() {
    // Assuming 'languageCode' is stored in localStorage
      const languageCode = localStorage.getItem('languageCode') || 'en'; // Use 'en' as default if not found

      this.api.getPageCode().subscribe(pageCode => {
        const aboutUsPageCode = 'Privacy_Policy';

        this.api.getPageContent(aboutUsPageCode, languageCode).subscribe(response => {
          this.privacyPolicyContent = response.data; // Assign the content to the variable
          this.metaService.updateTag({
            name: 'title', content: this.privacyPolicyContent.meta_title
          });

          this.metaService.updateTag({
            name: 'keywords', content: this.privacyPolicyContent.keywords
          });

          this.metaService.updateTag({
            name: 'description', content: this.privacyPolicyContent.meta_description
          });
        });
      });
  }

}
